import React  from 'react'
import { Map, Marker, ZoomControl } from 'pigeon-maps'
import { osm } from 'pigeon-maps/providers'
import {FaEnvelope, FaLink, FaPhone} from "react-icons/fa6";
import { Main, AboutBody, AboutBox, TextBox } from './commonStyles';
import SafeTextToHTML from "../components/SafeTextToHTML";


export default function About({content, smallWindow, windowSize}) {

    const latLong = JSON.parse(content.about.latLong);
    const mapHeight = Math.max(windowSize.height/2, 500);

    return (
        <Main content={content.styles}>
            {(smallWindow) ? <h2>&nbsp;{content.about.title}</h2> : null}
            <AboutBody content={{smallWindow: smallWindow}}>
                <AboutBox content={{...content.styles, 'maxBoxWidth': 'Narrow'}}>
                    <TextBox>
                        <h3>&nbsp;Contact</h3>
                        <p>&nbsp;</p>

                        {(content.about.phone) ? 
                            <>
                                <div style={{color: content.styles.highlightColor}}>
                                    <FaPhone/>&nbsp; Phone: &nbsp;
                                    <a href={"tel:" + content.about.phone} style={{color: content.styles.textBoxTextColor}}>{content.about.phone}</a>
                                </div>
                                <p>&nbsp;</p>
                            </> 
                        : null}

                        {(content.about.email) ? 
                            <>
                                <div style={{color: content.styles.highlightColor}}>
                                    <FaEnvelope/>&nbsp; Email: &nbsp;
                                    <a href={"mailto:" + content.about.email} style={{color: content.styles.textBoxTextColor}}>{content.about.email}</a>
                                </div>
                                <p>&nbsp;</p>
                            </> 
                        : null}
                        
                        {(content.about.contactInstructions) ? <SafeTextToHTML text={content.about.contactInstructions} /> : ""}
                    </TextBox>
                </AboutBox>

                {(content.about.openingHours && content.about.openingHours.length > 0) ? 
                    <AboutBox content={{...content.styles, 'maxBoxWidth': 'Narrow'}}>
                        <TextBox>
                            <h3>&nbsp;Opening Times</h3>
                            <p>&nbsp;</p>
                            <SafeTextToHTML text={content.about.openingHours} />
                        </TextBox>
                    </AboutBox>
                : null}

                <AboutBox content={{...content.styles, 'maxBoxWidth': 'Narrow'}}>
                    <TextBox>
                        <h3>&nbsp;Address</h3>
                        <p>&nbsp;</p>
                        <SafeTextToHTML text={content.about.address} />
                    </TextBox>
                </AboutBox>
                
                {content.about.registrationNumbers && content.about.registrationNumbers.length > 0 ?
                    <AboutBox content={{...content.styles, 'maxBoxWidth': 'Narrow'}}>
                        <TextBox>
                            <h3>&nbsp;Registration</h3>
                            <p>&nbsp;</p>
                            <SafeTextToHTML text={content.about.registrationNumbers} />
                        </TextBox>
                    </AboutBox>
                                
                : null}

                {(content.about.onlineEnabled) ? 
                    <AboutBox content={{...content.styles, 'maxBoxWidth': 'Narrow'}}>
                        <TextBox>
                            <h3>&nbsp;{content.about.onlineTitle}</h3>
                            <p>&nbsp;</p>
                            <SafeTextToHTML text={content.about.onlineInstructions} />
                            <p>&nbsp;</p>
                            <FaLink style={{color: content.styles.highlightColor}}/>&nbsp;
                            <a href={content.about.onlineUrl} style={{color: content.styles.textBoxTextColor}}><u>{content.about.onlineUrlText}</u></a>
                        </TextBox>
                    </AboutBox>
                : null}

                
                <AboutBox content={{...content.styles, 'maxBoxWidth': 'Max'}}>
                    <TextBox>
                        <a href={'https://www.google.com/maps/dir/?api=1&map_action=map&center=' + JSON.stringify(latLong.coord) + '&destination=' + JSON.stringify(latLong.coord)} 
                        style={{color: content.styles.textBoxTextColor}} target="_blank" rel="noopener noreferrer"><u>Click</u> to view directions on Google Maps</a>
                        <p>&nbsp;</p>
                        <div style={{textAlign:'center', border:'1px solid black', height: String(mapHeight) + 'px', width: '100%'}}>
                        <Map key='map' provider={osm} center={latLong.coord} zoom={latLong.zoom} twoFingerDrag={true} metaWheelZoom={true}>
                            {(content.about.mapEnabled) ? <Marker width={50} anchor={latLong.coord} color={'red'}/> : null}
                            <ZoomControl />
                        </Map>
                        </div>
                    </TextBox>
                </AboutBox>
                
            </AboutBody>
            
        </Main>
    )
}

